import React from 'react'

const InputTextModalComp = React.forwardRef(({
    label,
    name,
    value,
    error,
    className,
    hoverMessage,
    maxLength,
    max,
    min,
    pattern,
    type,
    ...rest
},
    ref
) => (
    <div className="row mb-2 ms-1" title={hoverMessage}>
        <label
            htmlFor={name}
            className="col-12 col-md-4 border rounded col-form-label fw-bold"
            style={{ color: '#495058' }}
        >
            {label}
        </label>
        <div className="col-12 col-md-8 mt-2 mt-md-0">
            <input
                className={`form-control text-dark ${className}`}
                name={name}
                value={value}
                ref={ref}
                {...rest}
                required
                maxLength={maxLength}
                max={max}
                min={min}
                pattern={pattern}
                type={type}
                title={value}
            />
        </div>
        {error && <p className="text-danger mt-2">{error.message}</p>}
    </div>
));

export default InputTextModalComp;